import React from 'react';
import { useTranslation } from 'react-i18next';
import diaryPreviewMobileImg from '@/assets/images/diary-preview-mobile.webp';
import diaryPreviewImg from '@/assets/images/diary-preview.webp';

export const HomeDiaryPaywall: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="relative flex overflow-hidden rounded-2xl bg-card shadow-card contrast:border contrast:border-border">
      <div className="relative z-10 flex min-w-0 flex-1 flex-col gap-2 p-6 pr-36 pb-24 md:gap-3 md:p-8 md:pb-26">
        <h3 className="text-title-24 text-foreground">
          {t('home.dashboard.subscriptionTitle')}
        </h3>
        <p className="text-body-13 text-muted-foreground md:text-body-14">
          {t('home.diary.subscriptionDescription')}
        </p>
      </div>

      <img
        src={diaryPreviewMobileImg}
        alt=""
        className="absolute right-0 bottom-0 w-[145px] md:hidden"
      />

      <img
        src={diaryPreviewImg}
        alt=""
        className="hidden w-[70%] shrink-0 self-end object-contain object-right-bottom md:block"
      />
    </div>
  );
};
